<template>
  <div class="mm-page-main" v-loading="loading">
    <div class="pagemain">
      <div class="form-group">
        <div v-if="datas.length==0">
            <p style="text-align:center">
              無相關匯款信息
            </p>
          </div>
        <div class="form-group-content" v-if="datas.length!=0">
          <div class="mm-row">
            <div class="mm-col">
              <div class="mm-item mb20">
                <label class="mm-label">匯款貨幣：</label>
                <el-radio-group disabled v-model="datas.area">
                  <el-radio-button label="0">港幣</el-radio-button>
                  <el-radio-button label="1">人民幣</el-radio-button>
                  <el-radio-button label="2">外幣</el-radio-button>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div v-if="datas.area == 0">
            <hkbanksinfo  :data="datas" />
          </div>
          <div v-if="datas.area == 1">
            <banksinfo  :data="datas" />
          </div>
          <div v-if="datas.area == 2">
            <overseasbanksinfo  :data="datas" />
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import banksinfo from "@/components/BanksInfo.vue";
import hkbanksinfo from "@/components/HKBanksInfo.vue";
import overseasbanksinfo from "@/components/OverseasBanksInfo.vue";
export default {
  components: {
    hkbanksinfo,
    banksinfo,
    overseasbanksinfo,
  },
  props: ['order_id'],
  data () {
    return {
      loading:true,
      clientpage: 'person',
      datas: []
    };
  },
  methods: {

    getdata () {
      this.post('/api/order/remitterinfo', {
        order_id: this.order_id,
      }).then((res) => {
        this.loading = false;
        this.datas = res;
      }).catch((err) => {

        console.log(err)
      })
    }
  },
  created () {

    this.getdata();
  }

};
</script>
<style scoped>
</style>
